// Box-Type Origin follows the Panel on the two side panels.
//
// Kevin, 2026-10-19: "for the box type if the panel is left then the origin is right bottom and
// read only. if the panel is right then the origin is left bottom and read only".
//
// Both are the bottom corner nearest the manway, seen standing outside the panel -- the reading
// the burner model already uses (public/burner/burner-configurator.html, boxIn). The value is
// set by operation cpq2-ndb-box-origin (operations.json, which cannot import this file, so it
// keeps its own copy of the two pairs); this file is the form's half: which cells to lock, and
// which loaded items keep the origin they were saved with.

import type { AnswerState } from "../types";

const ORIGIN_FOR_PANEL: Record<string, string> = { left: "Right-Bottom", right: "Left-Bottom" };

/** The origin a panel dictates, or null when the panel leaves it to the rep. */
export function originForPanel(panel: unknown): string | null {
  return ORIGIN_FOR_PANEL[String(panel ?? "").trim().toLowerCase()] ?? null;
}

/**
 * The inlets of a LOADED item that keep their saved origin: those on a side panel with a real
 * origin. Reps entered the opposite pairing for months (Right -> Right-Bottom on 84 inlets,
 * Left -> Left-Bottom on 83), and Kevin chose to leave those items alone, so an item opened in
 * Edit Config is not rewritten until an inlet's panel changes. Keyed by column ("MAIN_1"), the
 * value is the panel it was loaded with; the operation reads it as scratchpad.originKeep.
 */
export function originKeepOf(a: AnswerState): Record<string, string> {
  const keep: Record<string, string> = {};
  for (const key of Object.keys(a)) {
    if (!key.startsWith("PANEL/")) continue;
    const col = key.slice("PANEL/".length);
    const panel = String(a[key] ?? "").trim();
    const origin = String(a[`ORIGIN/${col}`] ?? "").trim();
    if (originForPanel(panel) && /^(Left|Right)-Bottom$/.test(origin)) keep[col] = panel;
  }
  return keep;
}
